// kh-age-gate.js — Age Gate · sessionStorage · kautabak-handel.com

(function () {
  var SESSION_KEY   = 'kh_age_verified';
  var REDIRECT_URL  = 'https://www.kika.de'; // ← Ziel-URL bei "unter 18" hier anpassen

  var gate = document.getElementById('kh-age-gate');
  if (!gate) return;

  // Bereits verifiziert in dieser Session → sofort ausblenden
  if (sessionStorage.getItem(SESSION_KEY) === '1') {
    gate.style.display = 'none';
    return;
  }

  // Overlay einblenden — synchron, NICHT via requestAnimationFrame.
  // Ist der Tab im Hintergrund oder der Renderer gedrosselt, feuert rAF u. U.
  // minutenlang nicht. Das Gate haengt per CSS auf opacity:0 und liegt als
  // position:fixed/inset:0 ueber der Seite — es waere dann ein unsichtbarer
  // Klick-Blocker. Synchron setzen schliesst dieses Fenster.
  gate.classList.add('kh-age--visible');

  // Scroll sperren
  document.body.style.overflow = 'hidden';

  function verify() {
    sessionStorage.setItem(SESSION_KEY, '1');
    gate.classList.add('kh-age--hidden');
    gate.classList.remove('kh-age--visible');
    document.body.style.overflow = '';
    // Nach Animation entfernen
    setTimeout(function () {
      gate.style.display = 'none';
    }, 300);
  }

  function deny() {
    window.location.href = REDIRECT_URL;
  }

  var btnYes = document.getElementById('kh-age-yes');
  var btnNo  = document.getElementById('kh-age-no');

  if (btnYes) btnYes.addEventListener('click', verify);
  if (btnNo)  btnNo.addEventListener('click', deny);

  // ESC sperren — kein Schliessen ohne Bestaetigung
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') e.preventDefault();
  });

})();
